import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import CSS from "bootstrap/dist/css/bootstrap.css";
import App from "App";

import { MaterialUIControllerProvider } from "context";
import { Provider } from "react-redux";
import store from "redux/store";

ReactDOM.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </MaterialUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
